import { initializeApp, getApps } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCMdhybGwyAFaVXR0uYujXIAgZ5-1pbvzo",
    authDomain: "barkassa-dcf9d.firebaseapp.com",
    databaseURL: "https://barkassa-dcf9d-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "barkassa-dcf9d",
    storageBucket: "barkassa-dcf9d.appspot.com",
    messagingSenderId: "294821506615",
    appId: "1:294821506615:web:9b59297517fd62bbcb19b2"
  };

function getFirebaseApp() {
  if (getApps().length === 0) {
    return initializeApp(firebaseConfig);
  }
  return getApps()[0];
}

export async function signIn(email: string, password: string): Promise<string> {
  const app = getFirebaseApp();
  const auth = getAuth(app);
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  const idToken = await userCredential.user.getIdToken();
  return idToken;
}

export async function signUp(email: string, password: string): Promise<string> {
  const app = getFirebaseApp();
  const auth = getAuth(app);
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const idToken = await userCredential.user.getIdToken();
  return idToken;
}
